<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter" id="illus1">
<img alt="" class="w" id="id-6958584170595716768" src="Images/img0001.jpg"/>
</div>
<h2 class="ph">HISTORICAL</h2>
<p class="calibre3">Law enforcement lagged behind crime because the police were limited in
their spheres of action, while criminals were not. Therefore, when
Bergenholm invented the inertialess drive and commerce throughout the
Galaxy became commonplace, crime became so rampant as to threaten the
very existence of Civilization.</p>
<p class="calibre3">Thus came into being the Galactic Patrol, an organization whose highest
members are called "Lensmen." Each is identified by wearing the Lens, a
pseudoliving telepathic jewel matched to the ego of its wearer by those
master philosophers, the Arisians. The Lens cannot be either imitated
or counterfeited, since it glows with color when worn by its owner, and
since it kills any other who attempts to wear it.</p>
<p class="calibre3">Of each million selected candidates for the Lens all except about a
hundred fail to pass the grueling tests employed to weed out the unfit.
Kimball Kinnison graduated No. 1 in his class and was put in command
of the spaceship <i class="calibre9">Brittania</i>—a war vessel of a new type, using
explosives, even though such weapons had been obsolete for centuries.
The "pirates"—the Boskonian Conflict was just beginning, so that no
one yet suspected that the Patrol faced anything worse than highly
organized piracy—were gaining the upper hand because of a new and
apparently almost unlimited source of power. Kinnison was instructed to
capture one of the new-type pirate ships, in order to learn the secret
of that power.</p>
<p class="calibre3">He found and defeated a Boskonian warship. Peter VanBuskirk led the
storming party of Valerians—men of human type, but of extraordinary
size, strength and agility because of the enormous gravitational force
of their home planet—in wiping out those of the pirate crew not killed
in the battle between the two ships.</p>
<p class="calibre3">The scientists of the expedition secured the information desired. It
could not be transmitted to Prime Base, however, because the pirates
blanketed all channels of communication. Boskonian warships were
gathering, and the crippled <i class="calibre9">Brittania</i> could neither run nor
fight. Therefore each man was given a spool of tape bearing the data
and all the Patrolmen took to the lifeboats.</p>
<p class="calibre3">Kinnison and VanBuskirk, in one of the boats, were forced to land
upon the planet Delgon, where they joined forces with Worsel—later
to become Lensman Worsel—a winged, reptilian native of a neighboring
planet, Velantia. The three destroyed a number of the Overlords of
Delgon, a sadistic race of monsters who preyed upon the other races
of their solar system by sheer power of mind. Worsel accompanied the
Patrolmen to Velantia, where all the resources of the planet were
devoted to preparing defenses against the expected Boskonian attack.
Several others of the <i class="calibre9">Brittania's</i> lifeboats reached Velantia,
called by Worsel's prodigious mind working through Kinnison's ego and
Lens.</p>
<p class="calibre3">Kinnison finally succeeded in tapping a communicator beam, thus getting
one line upon Helmuth, who "spoke for Boskone"—it was supposed
then that Helmuth actually was Boskone instead of a comparatively
unimportant Director of Operations—and upon his Grand Base.</p>
<p class="calibre3">The Boskonians attacked Velantia and six of their vessels were
captured. In these ships, manned by Velantian crews, the Tellurians set
out for Earth and the Prime Base of the Galactic Patrol. Kinnison's
Bergenholm, the generator of the force which makes inertialess—"free,"
in space parlance—flight possible, broke down, wherefore he had to
land upon the planet Trenco for repairs.</p>
<p class="calibre3">Trenco, the tempestuous, billiard ball-smooth planet where it rains
forty-seven feet and five inches every night and where the wind blows
eight hundred miles an hour. Trenco, the world upon which is produced
thionite, the deadliest and most potent of all habit-forming drugs.
Trenco, the Mecca of all the "zwilniks"—members of the Boskonian
drug ring; sometimes loosely applied to any Boskonian—of the Galaxy.
Trenco, whose weirdly charged ether and atmosphere so distort beams and
vision that it can be policed only by such beings as the Rigellians,
who possess the sense of perception instead of sight and hearing!</p>
<p class="calibre3">Lensman Tregonsee, of Rigel IV, then in command of the Patrol's
wandering base upon Trenco, furnished Kinnison a new Bergenholm and he
again set out for Tellus.</p>
<p class="calibre3">Meanwhile Helmuth, the Boskonian commander, had deduced that some
one particular Lensman was back of all his setbacks; and that the
Lens, a complete enigma to the Boskonians, was in some way connected
with Arisia. That planet had always been dreaded and shunned by
all spacemen. No one would ever say why, but no being who had ever
approached that planet uninvited could be compelled, even by threat of
death, to go near it again.</p>
<p class="calibre3">Helmuth, thinking himself secure by virtue of his thought-screens, the
secret of which he had stolen from Velantia, went alone to Arisia, to
learn how the Lens gave its wearer such power. He was stopped at the
barrier. His thought-screens were useless—the Arisians had given them
to Velantia, hence knew how to break them down. He was punished to the
verge of insanity, but was finally permitted to return to his Grand
Base, alive and sane: "Not for your own good, but for the good of that
struggling young civilization which you oppose."</p>
<p class="calibre3">Kinnison finally reached Prime Base with the all-important data. By
building superpowerful battleships, called "maulers," the Patrol
gained a temporary advantage over Boskonia, but a stalemate soon
ensued. Kinnison developed a plan of action whereby he hoped to locate
Helmuth's Grand Base; and asked Port Admiral Haynes, Chief of Staff
of the entire Patrol, for permission to follow it. In lieu of that,
however, Haynes informed him that he had been given his Release; that
he was an Unattached Lensman—a "Gray" Lensman, popularly so called,
from the color of the plain leather uniforms they wear. Thus he earned
the highest honor which the Galactic Patrol can bestow, for the Gray
Lensman works under no direction whatever. He is as absolutely a free
agent as it is possible to be. He is responsible to no one; to nothing
save his own conscience. He is no longer of Tellus, nor of the Solarian
System, but of the Universe as a whole. He is no longer a cog in the
immense machine of the Patrol: wherever he may go, throughout the
unbounded reaches of space, he <i class="calibre9">is</i> the Patrol!</p>
<p class="calibre3">In quest of a second line upon Grand Base, Kinnison scouted a pirate
stronghold upon Aldebaran I. Its personnel, however, were not even
near-human, but were Wheelmen, possessed of the sense of perception;
hence Kinnison was discovered before he could accomplish anything and
was very seriously wounded. He managed to get back to his speedster and
to send a thought to Port Admiral Haynes, who immediately rushed ships
to his aid. In Base Hospital, Surgeon General Lacy put him together,
and, during a long and quarrelsome convalescence, Nurse Clarrissa
MacDougall held him together. Lacy and Haynes connived to promote a
romance between nurse and Lensman.</p>
<p class="calibre3">As soon as he could leave the hospital he went to Arisia in the hope
that he might be permitted to take advanced training; an unheard-of
idea. Much to his surprise, he learned that he had been expected to
return, for exactly such training. Getting it almost killed him, but he
emerged infinitely stronger of mind than any man had ever been before.
He also now had the sense of perception; a sense somewhat analogous to
that of sight, but of vastly greater penetration, power and scope and
not dependent upon light; a sense only vaguely forecast by ancient work
upon clairvoyance.</p>
<p class="calibre3">By the use of his new mental equipment he succeeded in entering a
Boskonian base upon Boyssia II. There he took over the mind of the
communications officer and waited. A pirate ship working out of
that base captured a hospital ship of the Patrol and brought it in.
Clarrissa, now chief nurse of the captured vessel, working under
Kinnison's instructions, stirred up trouble. Helmuth, from Grand Base,
interfered, thus enabling the Lensman to get his second, all-important
line.</p>
<p class="calibre3">The intersection of the two lines, Boskonia's Grand Base, lay in a star
cluster well outside the Galaxy. Pausing only long enough to destroy
the Wheelmen of Aldebaran I, the project in which his first attempt had
failed so dismally, he investigated Helmuth's headquarters. He found
fortifications impregnable to any massed attack of the Patrol, manned
by beings wearing thought-screens. His sense of perception was suddenly
cut off—the enemy had thrown a thought-screen around the whole planet.</p>
<p class="calibre3">He returned to Prime Base, deciding en route that boring from within
was the only possible way in which that base could be reduced. In
consultation with Haynes the zero hour was set, at which the Grand
Fleet of the Patrol would start raying Helmuth's base with every
available projector.</p>
<p class="calibre3">Pursuant to his plan, Kinnison again visited Trenco, where Tregonsee
and his Rigellians extracted for him fifty kilograms of thionite,
the noxious drug which, in microgram inhalations, makes the addict
experience all the physical and mental sensations of doing whatever it
is that he wishes most ardently to do. The larger the dose the more
intense the sensations—but the slightest overdose means a sudden and
super-ecstatic death.</p>
<p class="calibre3">Thence to Helmuth's planet; where, by controlling the muscles of a
dog whose brain was unscreened, he let himself into the central dome.
Here, just before zero time, he released his thionite into the primary
air stream, thus wiping out all the pirate personnel except Helmuth;
who, in his inner dome, could not be affected. The Patrol attacked
on schedule. Kinnison killed Helmuth in hand-to-hand combat. Grand
Base was blasted out of existence, largely by the explosion of bombs
of duodecaplyl atomate placed by the pirates themselves. These bombs
were detonated by an enigmatic, sparkling force-ball which Kinnison
had studied with care. He knew that it was operated by thought, and
he suspected—correctly—that it was in reality an intergalactic
communicator.</p>
<p class="calibre3">Kinnison's search for the real Boskone lead to Lundmark's Nebula,
thenceforth called the Second Galaxy. His ship, the superpowerful
<i class="calibre9">Dauntless</i>, met and defeated a squadron of Boskonian warships.
The Tellurians landed upon the planet Medon, whose people were fighting
a losing war against the forces of Boskone. The Medonians, electrical
wizards who had been able to install inertia-neutralizers and a space
drive upon their planet, moved their world over to our First Galaxy.</p>
<p class="calibre3">With the cessation of military activity, however, the illicit traffic
in habit-forming drugs amongst all races of warm-blooded oxygen
breathers had increased tremendously; and Kinnison, deducing that
Boskone was back of the Drug Syndicate, decided that the best way to
find the real leader of the enemy was to work upward through the drug
ring.</p>
<p class="calibre3">Disguised as a dock walloper, he frequented the saloon of a drug baron,
and helped to raid it; but, although he secured much information, his
disguise was penetrated.</p>
<p class="calibre3">He called a Conference of Scientists, to devise means of building a
gigantic bomb of negative matter. Then, impersonating a Tellurian
secret-service agent who lent himself to the deception, he tried to
investigate the stronghold of Prellin of Bronseca, one of Boskone's
Regional Directors. This disguise also failed and he barely escaped.</p>
<p class="calibre3">Ordinary disguises having proved useless against Boskone's clever
agents, Kinnison himself became Wild Bill Williams; once a gentleman
of Aldebaran II, now a space rat meteor miner. Instead of pretending
to drink he really drank; making of himself a practically bottomless
drinker of the most vicious beverages known to space. He became a drug
fiend—a bentlam eater—discovering that his Arisian-developed mind
could function at full efficiency even while his physical body was
stupefied. He became widely known as the fastest, deadliest performer
with twin ray guns that had ever struck the asteroid belts. Thus,
through solar system after solar system, he built up an unimpeachable
identity as a hard-drinking, wildly carousing, bentlam-eating,
fast-shooting space hellion; a lucky or a very skillful meteor miner;
a derelict who had been an Aldebaranian gentleman once and who would
be again if he should ever strike it rich and if he could conquer his
weaknesses.</p>
<p class="calibre3">Physically helpless in a bentlam stupor, he listened in on a zwilnik
conference and learned that Edmund Crowninshield, of Tressilia III, was
also a Regional Director of the enemy.</p>
<p class="calibre3">Boskone formed an alliance with the Overlords of Delgon, and through
a hyperspatial tube or vortex the combined forces again attacked
humanity. Not simple slaughter this time, for the Overlords tortured
their captives and consumed their life forces in sadistic orgies.
The Conference of Scientists solved the mystery of the tube and the
<i class="calibre9">Dauntless</i> attacked through it; returning victorious.</p>
<p class="calibre3">Wild Bill Williams struck it rich at last. Forthwith he abandoned the
low dives in which he had been wont to carouse, and made an obvious
effort to become again an Aldebaranian gentleman. He secured an
invitation to visit Crowninshield's resort. The Boskonian, believing
that Williams was basically a drink and drug-soaked bum, took him in,
to get his quarter-million credits. Relapsing into a characteristically
wild debauch, Kinnison-Williams did squander a large part of his new
fortune; but he learned from Crowninshield's mind that one Jalte, a
Kalonian by birth, was Boskone's Galactic Director and that Jalte had
his headquarters in a star cluster just outside the First Galaxy.
Pretending bitter humiliation and declaring that he would change his
name and disappear, the Gray Lensman left the planet—to investigate
Jalte's base.</p>
<p class="calibre3">He learned that Boskone was not a single entity, but was a council. He
also learned that, while the Kalonian did not know who or where Boskone
was, Eichmil, Jalte's superior, who lived upon the planet Jarnevon in
the Second Galaxy, would probably know all about it.</p>
<p class="calibre3">Kinnison and Worsel, therefore, set out to investigate Jarnevon.
Kinnison was captured and tortured—there was at least one Delgonian
upon Jarnevon—but Worsel rescued him before his mind was damaged and
brought him back to the Patrol's Grand Fleet with his knowledge intact.
Jarnevon was populated by the Eich, a race of monsters as bad as the
Overlords of Delgon; the Council of Nine which ruled the noisome planet
was, in fact, the long-sought, the utterly detested Boskone!</p>
<p class="calibre3">The greatest surgeons of the age—Phillips of Posenia and Wise of the
newly acquired planet Medon—demonstrated that they could grow new
nervous tissue; even new limbs and organs if necessary.</p>
<p class="calibre3">Again Clarrissa MacDougall nursed Kinnison back to health, and this
time the love between them would not be denied.</p>
<p class="calibre3">The Grand Fleet of the Patrol was assembled, and with Kinnison in
charge of Operations, swept outward from the First Galaxy. Jalte's
planet was destroyed by means of the negasphere—the negative-matter
bomb. Then on to the Second Galaxy.</p>
<p class="calibre3">There the Patrol forces destroyed Jarnevon, the planet of the Eich, by
smashing it between two barren planets which had been driven there
in the "free"—inertialess—condition. These planets, having opposite
intrinsic velocities, were placed one upon each side of Jarnevon. Then
their Bergenholms were cut, restoring inertia and intrinsic velocity;
and when that frightful collision was over a minor star had come into
being.</p>
<p class="calibre3">Grand Fleet returned to our Galaxy. Galactic Civilization rejoiced.
Earth in particular made merry, and Prime Base was the center of
celebration. And in Prime Base Kinnison, supposing that the war was
over and that his problem was solved, threw off his Gray Lensman's
burden and forgot all about the Boskonian menace. Marrying his Chris,
he declared, was the most important thing in the Universe.</p>
<p class="calibre3">But how wrong he was! For, even as Lensman and Sector Chief Nurse were
walking down a hallway of Base Hospital after a conference with Lacy
and Haynes regarding that marriage—</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?97a45126